// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const LinkOffOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 16 16","focusable":"false"},"children":[{"tag":"g","attrs":{"clip-path":"url(#clip0_2482_22378)"},"children":[{"tag":"path","attrs":{"d":"M9.6 7.33l1.07 1.08V7.33H9.59zm1.73-2.66H8.67v1.26h2.66a2.07 2.07 0 01.82 3.96l.94.94a3.32 3.32 0 00-1.76-6.16zm-10-1.82l2.08 2.07a3.33 3.33 0 001.26 6.41h2.66v-1.26H4.67a2.06 2.06 0 01-.23-4.11l1.38 1.37h-.49v1.34h1.82l1.52 1.51v1.15h1.15l2.67 2.68.94-.94L2.27 1.9l-.94.94z","fill":"currentColor"}}]},{"tag":"defs","attrs":{},"children":[{"tag":"clipPath","attrs":{"id":"clip0_2482_22378"},"children":[{"tag":"path","attrs":{"d":"M0 0h16v16H0z","fill":"currentColor"}}]}]}]},"name":"link_off","theme":"outlined"};

const LinkOffOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={LinkOffOutlinedSvg} />;
  LinkOffOutlined.displayName = 'LinkOffOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(LinkOffOutlined);
